import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CdwTableColumn {
  /** Column header text */
  header: string;
  /** Field name from data object */
  field: string;
  /** Optional custom width (e.g., '200px', '30%') */
  width?: string;
  /** Optional text alignment */
  align?: 'left' | 'center' | 'right';
  /** Optional custom cell class */
  cellClass?: string;
  /** Optional custom header class */
  headerClass?: string;
}

@Component({
  selector: 'lib-cdw-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cdw-table.component.html',
  styleUrls: ['./cdw-table.component.scss'],
})
export class CdwTableComponent {
  /** Column definitions for the table */
  @Input() columns: CdwTableColumn[] = [];

  /** Data to display in the table */
  @Input() data: unknown[] = [];

  /** Optional custom class for the entire table container */
  @Input() tableClass = '';

  /** Optional custom class for table headers */
  @Input() headerClass = '';

  /** Optional custom class for table rows */
  @Input() rowClass = '';

  /** Optional custom class for table cells */
  @Input() cellClass = '';

  /** Style class for the table (e.g., 'cdw-table-default') */
  @Input() styleClass = 'cdw-table-default';

  /** Background color for header */
  @Input() headerBgColor = '#f9fafb';

  /** Border color */
  @Input() borderColor = '#e5e7eb';

  /** Alternate row background color */
  @Input() alternateRowBgColor = '#ffffff';

  /** Show border radius on the table container */
  @Input() showBorderRadius = false;

  /** Show box shadow on the table container */
  @Input() showBoxShadow = false;

  /**
   * Get value from a data object by field name
   */
  getCellValue(row: unknown, field: string): unknown {
    return (row as Record<string, unknown>)[field];
  }

  /**
   * Get combined cell classes
   */
  getCellClasses(column: CdwTableColumn): string {
    const classes = [this.cellClass];
    if (column.cellClass) {
      classes.push(column.cellClass);
    }
    if (column.align) {
      classes.push(`text-${column.align}`);
    }
    return classes.filter(Boolean).join(' ');
  }

  /**
   * Get combined header classes
   */
  getHeaderClasses(column: CdwTableColumn): string {
    const classes = [this.headerClass];
    if (column.headerClass) {
      classes.push(column.headerClass);
    }
    if (column.align) {
      classes.push(`text-${column.align}`);
    }
    return classes.filter(Boolean).join(' ');
  }
}
